import { Runtime } from '@/core/enums/runtime.enum'

/**
 * Constructor token used inside the method filter, per runtime.
 * Example: filtering `constructor` (or `initialize` on Ruby) keeps constructors exposed.
 */
export function getConstructorToken(runtime: Runtime): string {
  switch (runtime) {
    case Runtime.Ruby:
      return 'initialize'
    case Runtime.Python:
      return '__init__'
    default:
      return 'constructor'
  }
}
